module.exports = __webpack_public_path__ + "img/lg_ring_y_o_null_null.bb40b8ff.png";